<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    class="custom-tabbar"
    active-color="#f3d27a"
    inactive-color="#9a907c"
    :border="false"
    route
  >
    <!-- 首页 -->
    <van-tabbar-item to="/Home" class="tab-item tab-home">
      <span class="tab-text">{{ $t("foorter.index") }}</span>
      <template #icon="props">
        <div class="tab-icon-wrap" :class="{ 'is-active': props.active }">
          <svg class="tab-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 10.6 12 4.2l8 6.4V20a1 1 0 0 1-1 1h-5.1v-5.4H10.1V21H5a1 1 0 0 1-1-1v-9.4Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
          </svg>
        </div>
      </template>
    </van-tabbar-item>

    <!-- 预约 -->
    <van-tabbar-item to="/Game" class="tab-item tab-game">
      <span class="tab-text">{{ $t("foorter.subscribe") }}</span>
      <template #icon="props">
        <div class="tab-icon-wrap" :class="{ 'is-active': props.active }">
          <svg class="tab-icon" viewBox="0 0 24 24" aria-hidden="true">
            <rect x="4" y="5.2" width="16" height="14.3" rx="2" fill="none" stroke="currentColor" stroke-width="1.7"/>
            <path d="M8 3.6v3.2M16 3.6v3.2M4 9.4h16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
          </svg>
        </div>
      </template>
    </van-tabbar-item>

    <!-- 中间 -->
    <van-tabbar-item to="/Choose" class="middle-tab-item">
      <template #icon="props">
        <div class="middle-btn-wrap" :class="{ 'middle-active': props.active }">
          <div class="middle-btn">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 19.6s-6.5-4-6.5-8.3A3.7 3.7 0 0 1 9.4 7c1.2 0 2.2.6 2.6 1.6.4-1 1.4-1.6 2.6-1.6a3.7 3.7 0 0 1 3.9 4.3c0 4.3-6.5 8.3-6.5 8.3Z" fill="currentColor"/>
            </svg>
          </div>
        </div>
      </template>
    </van-tabbar-item>

    <!-- 视频 -->
    <van-tabbar-item to="/Video" class="tab-item tab-video">
      <span class="tab-text">{{ $t("foorter.video") }}</span>
      <template #icon="props">
        <div class="tab-icon-wrap" :class="{ 'is-active': props.active }">
          <svg class="tab-icon" viewBox="0 0 24 24" aria-hidden="true">
            <rect x="3.4" y="6" width="17.2" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.7"/>
            <path d="M10.2 9.2v5.6l4.8-2.8-4.8-2.8Z" fill="currentColor"/>
          </svg>
        </div>
      </template>
    </van-tabbar-item>

    <!-- 我的 -->
    <van-tabbar-item to="/Mine" class="tab-item tab-mine">
      <span class="tab-text">{{ $t("foorter.my") }}</span>
      <template #icon="props">
        <div class="tab-icon-wrap" :class="{ 'is-active': props.active }">
          <svg class="tab-icon" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="8.2" r="3.1" fill="none" stroke="currentColor" stroke-width="1.7"/>
            <path d="M5.4 19.3c1.2-2.9 3.5-4.3 6.6-4.3s5.4 1.4 6.6 4.3" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
          </svg>
        </div>
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0
    };
  },
  watch: {
    $route(to) {
      if (to.name == "home") {
        this.active = 0;
        this.show = true;
      } else if (to.name == "game") {
        this.active = 1;
        this.show = true;
      } else if (to.name == "choose") {
        this.active = 2;
        this.show = true;
      } else if (to.name == "video") {
        this.active = 3;
        this.show = true;
      } else if (to.name == "mine") {
        this.active = 4;
        this.show = true;
      } else {
        this.show = false;
      }
    }
  },
  created() {
    if (this.$route.name == "home") {
      this.active = 0;
      this.show = true;
    } else if (this.$route.name == "game") {
      this.active = 1;
      this.show = true;
    } else if (this.$route.name == "choose") {
      this.active = 2;
      this.show = true;
    } else if (this.$route.name == "video") {
      this.active = 3;
      this.show = true;
    } else if (this.$route.name == "mine") {
      this.active = 4;
      this.show = true;
    } else {
      this.show = false;
    }
  }
};
</script>

<style lang="less" scoped>
.custom-tabbar {
  height: calc(64PX + env(safe-area-inset-bottom));
  padding: 4PX 6PX env(safe-area-inset-bottom);
  box-sizing: border-box;
  background: rgba(8, 6, 12, 0.96);
  border-top: 1PX solid rgba(244, 216, 131, 0.2);
  box-shadow: 0 -12PX 28PX rgba(0, 0, 0, 0.42);
  backdrop-filter: blur(18PX);
  z-index: 999 !important;
}

::v-deep .van-tabbar {
  z-index: 999 !important;
  background: transparent;
}

::v-deep .van-tabbar-item {
  min-width: 0;
  padding: 2PX 2PX 0;
  background: transparent !important;
  color: #9a907c;
}

::v-deep .van-tabbar-item--active {
  color: #f3d27a;
  background: transparent !important;
}

::v-deep .van-tabbar-item__icon {
  margin-bottom: 0;
  height: auto;
}

::v-deep .van-tabbar-item__text {
  font-size: 11PX;
  font-weight: 600;
  margin-top: 2PX;
  line-height: 1.15;
}

.tab-text {
  display: block;
  text-align: center;
  white-space: nowrap;
}

.tab-icon-wrap {
  width: 28PX;
  height: 26PX;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9PX;
  color: inherit;
}

.tab-icon-wrap.is-active {
  background: rgba(243, 210, 122, 0.14);
  box-shadow: inset 0 0 0 1PX rgba(243, 210, 122, 0.32);
}

.tab-icon {
  width: 22PX;
  height: 22PX;
  display: block;
}

.middle-tab-item {
  overflow: visible;
}

.middle-btn-wrap {
  position: relative;
  width: 54PX;
  height: 54PX;
  margin-top: -24PX;
  display: flex;
  align-items: center;
  justify-content: center;
}

.middle-btn {
  width: 50PX;
  height: 50PX;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a320c;
  background: linear-gradient(160deg, #fff6d4 0%, #f0d48a 46%, #c9963a 100%);
  border: 3PX solid #120e16;
  box-shadow: 0 8PX 16PX rgba(201, 150, 58, 0.38), inset 0 0 0 1PX rgba(255, 244, 214, 0.65);
}

.middle-btn svg {
  width: 24PX;
  height: 24PX;
  display: block;
}

.middle-active .middle-btn {
  box-shadow: 0 0 0 4PX rgba(243, 210, 122, 0.16), 0 8PX 18PX rgba(243, 210, 122, 0.42), inset 0 0 0 1PX rgba(255, 244, 214, 0.8);
}

::v-deep .middle-tab-item .van-tabbar-item__text {
  display: none;
}

[class*="van-hairline"]::after {
  border: none !important;
}

::v-deep .van-tabbar::after {
  border: none !important;
}
</style>
